import { connect } from "react-redux";
import Feed from "./Feed.jsx"
import { fetchAllWorkInstructions } from "../../../redux/actions/wi_actions"
import { fetchAllUsers, fetchIncomingNotifications} from '../../../redux/actions/user_actions';
//this container will be used to optimize the number of api request made to the backend.
//It should only be incorporated in conjuction with shouldComponentUpdate()
const mapStateToProps = (state) => {
    return ({
        users: state.users,
        currentUser: state.session.user,
        currentUserId: state.session.user._id,
        notifications: Object.values(state.notifications),
        workInstructions: Object.values(state.work_instructions.all),
    });
}

const mapDispatchToProps = (dispatch) => {
    return ({
        fetchIncomingNotifications: (currentUserId) => dispatch(fetchIncomingNotifications(currentUserId)),
        fetchAllWorkInstructions: (cancelToken) => dispatch(fetchAllWorkInstructions(cancelToken)),
        fetchAllUsers: (cancelToken) => dispatch(fetchAllUsers(cancelToken)),
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(Feed);